export const Titles = [
  "ma'am([.]\\s*|\\s+)",
  "misses([.]\\s*|\\s+)",
  "missus([.]\\s*|\\s+)",
  "miss([.]\\s*|\\s+)",
  "maam([.]\\s*|\\s+)",
  "madam([.]\\s*|\\s+)",
  "mrs([.]\\s*|\\s+)",
  "mr([.]\\s*|\\s+)",
  "dr([.]\\s*|\\s+)",
  "doctor([.]\\s*|\\s+)",
  "engr([.]\\s*|\\s+)",
  "engineer([.]\\s*|\\s+)",
  "engg([.]\\s*|\\s+)",
  "ms([.]\\s*|\\s+)",
];
